<template>
  <div :class="{ 'c-dark-theme': $store.state.darkMode }" class="c-app">
    <CContainer class="d-flex align-items-center min-vh-100">
      <CRow class="w-100 justify-content-center">
        <CCol md="6" class="text-center">
          <CIcon name="cil-warning" size="4xl" class="text-danger mb-3" />
          <h1 class="h4 font-weight-bold">Something went wrong on our side</h1>
          <p class="text-muted">This page is unavailable right now. Try again in a few minutes.</p>
          <CButton color="primary" to="/">Go to the dashboard</CButton>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Page500'
}
</script>
